import React from 'react';


interface WithCollapsablesState<T> {
  collapsedSections: Set<T>;
}

interface WithCollapsablesRenderProps<T> extends WithCollapsablesState<T> {
  makeSectionToggler: (section: T) => () => void;
}

interface WithCollapsablesProps<T> {
  children: (props: WithCollapsablesRenderProps<T>) => JSX.Element;
  initiallyCollapsed?: T[];
}

export class WithCollapsables<T extends string> extends React.Component<WithCollapsablesProps<T>, WithCollapsablesState<T>> {
  constructor(props: WithCollapsablesProps<T>) {
    super(props);

    this.state = {
      collapsedSections: new Set(props.initiallyCollapsed),
    };
  }

  private makeSectionToggler = (section: T) => () => {
    this.setState((state) => {
      const setCopy = new Set(state.collapsedSections);
      if (setCopy.has(section)) setCopy.delete(section);
      else setCopy.add(section);

      return {
        collapsedSections: setCopy,
      };
    });
  }

  public render() {
    return (
      this.props.children({ ...this.state, makeSectionToggler: this.makeSectionToggler })
    );
  }
}
